import React, { Component } from 'react';
import { InputNumber as AntInput } from 'antd';

class InputNumber extends Component {
  updateInput = (value) => {
    this.props.updateSetting(this.props.settingKey, value);
  }
  render() {
    return (
      <div className="set-inputnumber">
        <h4>{this.props.settingsTitle}</h4>
        <AntInput style={{width: '100%'}} min={0} value={this.props.value} onChange={(value) => this.updateInput(value)} />
      </div>
    );
  }
}

export default InputNumber;
